import React, { Fragment, useState } from "react";
import DatePicker from "react-datepicker";
import InputLabel from "@material-ui/core/InputLabel";

const ReactBirthDatePicker = ({ setValue, value,label, name }) => {
    const [startDate, setStartDate] = useState(null);
    const handleChange = (date, name) => {
        if (date) {
            setStartDate(date);
            let convertDate = new Date(
                date.getTime() - date.getTimezoneOffset() * 60000
            ).toISOString();
            convertDate = convertDate.split("T")[1].split(".")[0];
            setValue(name, convertDate);
        } else {
            setStartDate("");
            setValue(name, "");
        }
    };
    return (
        <Fragment>
            <InputLabel>{label}</InputLabel>

            <DatePicker
                placeholderText="HH:mm:ss"
                dateFormat="HH:mm:ss"
                timeFormat="HH:mm:ss"
                timeIntervals={1}
                selected={startDate}
                onChange={(date) => handleChange(date, name)}
                showTimeSelect
                showTimeSelectOnly
                className="time-only"
                value={value.split(".")[0]}
            />
        </Fragment>
    );
};

export default ReactBirthDatePicker;
